module.exports = __webpack_public_path__ + "img/编组 58.26cd9593.png";